/**
 * @param params setters from Format
 */
export function setConfigR48(params) {
    const { setHeaders, setPdfConfig, setExcelConfig, setHtmlConfig, setData, filter } = params;
    const headers = [
        "TOTAL",
        "TOTAL CRI"
    ]
    setHeaders(headers)
    const tempData = {
        action: "reporteIniciativaLeyIngresos",
        year: (new Date(filter.year)).getFullYear(),
    }
    setData(tempData);
    const content = [
        { header: "TOTAL", value: "" },
        { header: "TOTAL CRI", value: "" },
    ];
    setHtmlConfig({
        headers,
        id: { id: "" },
        content: [content]
    })
    setPdfConfig({
        descr: tempData,
        headers,
        content: [content]
    });
    setExcelConfig({
        headers,
        content: [...content]
    });
}